/*
 * @Descripttion:
 * @Author: Xinner
 * @Date: 2021-01-26 09:28:03
 * @LastEditors: 景 彡
 * @LastEditTime: 2025-02-14 09:12:31
 */
import { RouterItem } from '@/utils/interfaces';
import AdminMainLayout from '@/layouts/admin/MainLayout.vue';

/** 系统管理 */
const routesMap: RouterItem[] = [
  {
    path: '/system-manage',
    component: AdminMainLayout,
    meta: {
      title: '监测数据',
    },
    children: [
      {
        path: 'user',
        component: () => import('@/views/search/me.vue'),
        name: 'User',
        meta: {
          title: '监测数据',
          icon: 'security-scan',
        },
      },
    ],
  },
  {
    path: '/search',
    component: AdminMainLayout,
    meta: {
      title: '信息搜索',
      icon: 'file-search',
    },
    children: [
      {
        path: '',
        component: () => import('@/views/search/index.vue'),
        name: 'Search',
        meta: {
          title: '信息搜索',
          icon: 'search',
        },
      },
      {
        path: 'detail',
        component: () => import('@/views/search/detail.vue'),
        name: 'Detail',
        meta: {
          title: '文章详情',
          icon: 'search',
          hidden: true,
        },
      },
    ],
  },
  {
    path: '/yqgl',
    component: AdminMainLayout,
    meta: {
      title: '舆情日报',
      icon: 'file-text',
    },
    children: [
      {
        path: 'manage',
        component: () => import('@/views/yqgl/manage.vue'),
        name: 'manage',
        meta: {
          title: '舆情日报管理',
        },
      },
      {
        path: 'today',
        component: () => import('@/views/yqgl/today.vue'),
        name: 'today',
        meta: {
          title: '今日舆情管理',
        },
      },
      //  {
      //   path: 'ysyq',
      //   component: () => import ('@/views/yqgl/ysyq.vue'),
      //   name: 'ysyq',
      //   meta: {
      //     title: '系统疑似舆情'
      //   }
      // },
    ],
  },
  {
    path: '/datastatistics',
    component: AdminMainLayout,
    meta: {
      title: '数据统计',
      icon: 'database',
    },
    children: [
      {
        path: 'qs-statistics',
        component: () => import('@/views/dataStatistics/qs-statisticsNew.vue'),
        name: 'qs-statistics',
        meta: {
          title: '舆情事件趋势统计',
        },
      },
      {
        path: 'type-statistics',
        component: () => import('@/views/dataStatistics/type-statistics.vue'),
        name: 'type-statistics',
        meta: {
          title: '事件类别统计',
        },
      },
      {
        path: 'tag-statistics',
        component: () => import('@/views/dataStatistics/tag-statistics.vue'),
        name: 'tag-statistics',
        meta: {
          title: '事件分类统计',
        },
      },
      // {
      // path: 'fsd-statistics',
      // component: () => import('@/views/dataStatistics/fsd-statistics.vue'),
      // name: 'fsd-statistics',
      // meta: {
      //     title: '事件发生地统计',
      // },
      // },
      {
        path: 'source-statistics',
        component: () => import('@/views/dataStatistics/source-statistics.vue'),
        name: 'source-statistics',
        meta: {
          title: '事件来源统计',
        },
      },
      {
        path: 'sjd-statistics',
        component: () => import('@/views/dataStatistics/sjd-statistics.vue'),
        name: 'sjd-statistics',
        meta: {
          title: '发生时间段统计',
        },
      },
    ],
  },
  {
    path: '/view',
    component: AdminMainLayout,
    name: 'dataDisplay',
    meta: {
      title: '数据展示',
      icon: 'line-chart',
    },
    // redirect: { name: 'dataView' },
    redirect: { name: 'tempDataView' },
  },
  // {
  //   path: '/temp-view',
  //   component: AdminMainLayout,
  //   name: 'tempDisplay',
  //   meta: {
  //     title: '数据展示1',
  //     icon: 'line-chart',
  //   },
  //   redirect: { name: 'tempDataView' },
  // },
  {
    path: '/personal',
    component: AdminMainLayout,
    meta: {
      title: '个人设置',
      icon: 'user',
    },
    children: [
      // {
      // path: 'information',
      // component: () => import('@/views/personalSettings/editInformation/index.vue'),
      // name: 'personal-information',
      // meta: {
      //     title: '修改信息',
      // },
      // },
      {
        path: 'password',
        component: () => import('@/views/personalSettings/editPassword/index.vue'),
        name: 'personal-password',
        meta: {
          title: '修改密码',
          icon: 'edit',
        },
      },
    ],
  },
];
export default routesMap;
